/**
 * Helpers for the project candidate list (`projects_pipeline_stages_users`).
 *
 * The project update endpoint replaces the whole list and deletes any row that is missing,
 * so every change must start from the full server list, binned rows included.
 */
export const updateCandidates = (candidates, ids, changes) =>
  candidates.map((candidate) =>
    ids.includes(candidate.id) ? { ...candidate, ...changes } : candidate,
  );

export const removeCandidates = (candidates, ids) =>
  candidates.filter((candidate) => !ids.includes(candidate.id));

export const addCandidate = (candidates, candidate) => {
  const existing = candidates.find((row) => row.user_id === candidate.user_id);

  if (existing) {
    return updateCandidates(candidates, [existing.id], {
      pipeline_stage_id: candidate.pipeline_stage_id,
      binned: 0,
    });
  }

  return [...candidates, { ...candidate, binned: 0 }];
};

export const toCandidatesPayload = (candidates) =>
  candidates.map(({ id, project_id, user_id, pipeline_stage_id, binned }) => ({
    id,
    project_id,
    user_id,
    pipeline_stage_id,
    binned: Number(binned) === 1 ? 1 : 0,
  }));
